import React from "react";
import RecruiterLayerBlueprint from "components/blueprints/RecruiterLayerBlueprint";

function RecruiterSettingsWorkspacePage() {
  return <div>RecruiterSettingsWorkspacePage</div>;
}

export default RecruiterLayerBlueprint(RecruiterSettingsWorkspacePage);
